export const DAILYROUND_CHECKPOINT = 'dailyround-checkpoints'
export const DAILYROUND_COCKPIT_SOURCE = 'dailyround_cockpit'
export const DAILYROUND_WEEKLY_MEETING_SOURCE = 'dr_weekly_meeting'
export const DEFAULT_WEEKLY_DAYS = [0, 1, 2, 3, 4, 5, 6]
export const DAILY_ROUNDS_COUNT_CHART_KEY = 'dr_count'
export const WEEKLY_MEETINGS_CHART_KEY = 'dr_weekly_meetings'
export const ACTIVITY_TIMES_CHART_KEY = 'dr_activity_times'
export const DR_WEEKLY_ACTIVITIES_CHART_KEY = 'dr_weekly_activities'
